import { apiRequest } from './client'
import type { BrainstormCategory, BrainstormEntry } from './types'

export const brainstormingApi = {
  list: (projectId: string, category?: BrainstormCategory) =>
    apiRequest<{ data: BrainstormEntry[] }>('/brainstorming', { query: { projectId, category } }),

  create: (input: { projectId: string; category: BrainstormCategory; title: string; body: string }) =>
    apiRequest<{ data: BrainstormEntry }>('/brainstorming', { method: 'POST', body: input }),

  update: (id: string, input: { category?: BrainstormCategory; title?: string; body?: string; progress?: number }) =>
    apiRequest<{ data: BrainstormEntry }>(`/brainstorming/${id}`, { method: 'PATCH', body: input }),

  remove: (id: string) => apiRequest<{ data: { success: boolean } }>(`/brainstorming/${id}`, { method: 'DELETE' }),

  setTasks: (id: string, taskIds: string[]) =>
    apiRequest<{ data: BrainstormEntry }>(`/brainstorming/${id}/tasks`, { method: 'PATCH', body: { taskIds } }),
}
